"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Lottie = exports.getLottieMetadata = void 0;
var get_lottie_metadata_1 = require("./get-lottie-metadata");
Object.defineProperty(exports, "getLottieMetadata", { enumerable: true, get: function () { return get_lottie_metadata_1.getLottieMetadata; } });
var Lottie_1 = require("./Lottie");
Object.defineProperty(exports, "Lottie", { enumerable: true, get: function () { return Lottie_1.Lottie; } });
